import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

import LanguageSelector from './LanguageSelector';
import Logo from './Logo';
import { AuthContext } from '../../contexts/AuthContext';
import TopAlert from './TopAlert';
import MenusLight from '../MenusLight';

import {
  HOME_PATH,
  LOGIN_PATH,
} from '../../config/routes';
import { useResto } from '../../contexts/RestoContext';
import TopDemo from './TopDemo';
import TopAdminMenu from './TopAdminMenu';
import { useIsWideScreen } from '../../contexts/WebsiteContext';

const SiteHeader = () => {
  const { isLoggedIn, handleLogout } = useContext(AuthContext);
  const { restoData } = useResto();
  const isWideScreen = useIsWideScreen();

  const logout = () => {
    handleLogout();
  };

  return (
    <div className="container-fluid">
      <div className="row background-main-color-80" style={{ color: 'rgba(255,255,255,0.7)' }}>

        <TopDemo />
        <TopAdminMenu />
        <TopAlert />

        <div className="col-8 d-flex align-items-center">
          <Link to={HOME_PATH} className="btn-link m-2">
            www.{restoData.website}.{restoData.extension}
          </Link>
          {isWideScreen && restoData.phone && <>- {restoData.phone}</>}
        </div>
        <div className="col-4 d-flex justify-content-end align-items-center">
          <LanguageSelector />
          {isLoggedIn ? (
            <>
              <FontAwesomeIcon
                icon={faSignOutAlt}
                style={{ marginLeft: '10px', cursor: 'pointer' }}
                onClick={logout}
              />
            </>
          ) : (
            <Link to={LOGIN_PATH} className="btn-link m-2">
              <FontAwesomeIcon
                icon={faSignInAlt}
                style={{ marginLeft: '10px', cursor: 'pointer' }}
              />
            </Link>
          )}
        </div>
      </div>
      { restoData && restoData.hasHeaderMenu && <div className='row'><MenusLight /></div>}
      <Logo />
    </div>
  );
}

export default SiteHeader;
